import { render, staticRenderFns } from "./StudyStatusList.vue?vue&type=template&id=2f77a7f9&"
import script from "./StudyStatusList.vue?vue&type=script&lang=js&"
export * from "./StudyStatusList.vue?vue&type=script&lang=js&"
import style0 from "./StudyStatusList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports